import { render, staticRenderFns } from "./InvoicesFilters.vue?vue&type=template&id=52b38e6a"
import script from "./InvoicesFilters.vue?vue&type=script&lang=js"
export * from "./InvoicesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports